React = require 'react'
t = require('views/internal/recup-with-helpers')('ask_an_admin')

module.exports = class extends React.Component
  displayName: 'AskAnAdminComponent'

  render: t.renderable ->
    { admins } = @props
    t.div ->
      t.div '.ask-an-admin', ->
        t.format 'seem-helpful-ask-an-admin-to-consider-upgrading-your-team'

      t.h3 ->
        t.format 'team-admins'

      t.ul '.organization-admin-list', ->
        admins.forEach (admin) ->
          t.li '.organization-admin-list-item', ->
            t.div '.organization-admin-list-item-avatar', ->
              avatarHash = admin.avatarHash
              if avatarHash
                if avatarHash
                  t.img { src: "#{ avatarDomain }/#{ avatarHash }/30.png" }
              else
                t.span '.icon.icon-lg.icon-member'

            t.div '.organization-admin-list-item-details', ->
              t.div '.organization-admin-list-item-name', ->
                t.text admin.fullName
              t.div '.organization-admin-list-item-username', ->
                t.text "@#{ admin.username }"



// WEBPACK FOOTER //
// ./app/scripts/views/organization/ask-an-admin-component.coffee